'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const components_display_VisuallyHidden_useIsKeyHeld = require('./useIsKeyHeld.cjs.js');

const visuallyHidden = "_visually-hidden_1swvj_1";
const styles = {
	visuallyHidden: visuallyHidden
};

const VisuallyHidden = (props) => {
  const isAltKeyHeld = components_display_VisuallyHidden_useIsKeyHeld.useIsKeyHeld("Alt");
  if (isAltKeyHeld) {
    return jsxRuntime.jsx(React.Fragment, { children: props.children });
  }
  return jsxRuntime.jsx("span", { className: styles.visuallyHidden, "data-testid": "visually-hidden", children: props.children });
};

exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.cjs.js.map
